<!-- 废弃 -->
<template>
	<div>
		<myheader headTitle="编辑CA申请"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<!-- <div class="all_tips_content_card">
					<div>企业信息</div>
					<div>{{'统一社会信用代码'}}</div>
					<div>{{'法定代表人姓名'}}</div>
					<div>{{'营业执照有效期'}}</div>
					<div>{{'法定代表人姓名'}}</div> -->
				<!-- <div class="text12 textcolor999 font_weight_bold">{{'认证方式：'+authStyleText}}</div>
					<span class="text12" style="position: absolute;right: .5rem; top: 1rem;color: #0277FC;"
						@click="flow_path_show = true">查看流程</span>
					<div class="text14 textcolor333 font_weight_900 margin_top_10">第一步：企业信息—上传证照</div>
					<div class="text12 textcolor333 margin_top_10">
						请上传清晰的企业营业执照原件及法人身份证件照片，确保清晰可见且不超过1.5MB。系统将通过照片自动对企业及法人信息进行识别。
					</div> -->
				<!-- </div> -->
				<div class="all_tips_content_card">
					<div class="all_text text14 font_weight_900 textcolor333 all_tips_red_after">企业营业执照</div>
					<div style="text-align: center;" class="margin_top_2">
						<van-uploader accept="image/*" v-model="businessLicense" :before-read="beforeRead"
							:after-read="afterReadBL" preview-size="7rem" :preview-full-image="licenseFilePreview">
							<img v-show="businessLicense.length===0"
								style="width: auto;min-width: 4rem;height: 7rem; object-fit: contain;"
								src="@/assets/images/u360.png">
						</van-uploader>
						<div class="text12 textcolor333 margin_top_2">点击拍照/上传</div>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_5">
					<div class="all_text text14 font_weight_900 textcolor333 all_tips_red_after">法人身份证照片</div>
					<div class="horizontal_flex flex_wrap margin_top_5">
						<div style="width: 50%;text-align: center;">
							<van-uploader accept="image/*" v-model="legalIdCardFront" :before-read="beforeRead"
								:after-read="afterReadLCF" preview-size="4rem"
								:preview-full-image="legalFrontFilePreview">
								<img v-show="legalIdCardFront.length===0" style="height: 4rem; "
									src="@/assets/images/kuan_gallery.svg">
							</van-uploader>
							<div class="text12 textcolor333 margin_top_2">点击上传正面照片</div>
						</div>
						<div style="width: 50%;text-align: center;">
							<van-uploader accept="image/*" v-model="legalIdCardBack" :before-read="beforeRead"
								:after-read="afterReadLCB" preview-size="4rem"
								:preview-full-image="legalBackFilePreview">
								<img v-show="legalIdCardBack.length===0" style="height: 4rem; "
									src="@/assets/images/kuan_gallery.svg">
							</van-uploader>
							<div class="text12 textcolor333 margin_top_2">点击上传背面照片</div>
						</div>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_5">
					<div class="all_text text14 font_weight_900 textcolor333 all_tips_red_after">经办人身份证照片</div>
					<div class="horizontal_flex flex_wrap margin_top_5">
						<div style="width: 50%;text-align: center;">
							<van-uploader accept="image/*" v-model="operIdCardFront" :before-read="beforeRead"
								:after-read="afterReadOCF" preview-size="4rem"
								:preview-full-image="operFrontFilePreview">
								<img v-show="operIdCardFront.length===0" style="height: 4rem; "
									src="@/assets/images/kuan_gallery.svg">
							</van-uploader>
							<div class="text12 textcolor333 margin_top_2">点击上传正面照片</div>
						</div>
						<div style="width: 50%;text-align: center;">
							<van-uploader accept="image/*" v-model="operIdCardBack" :before-read="beforeRead"
								:after-read="afterReadOCB" preview-size="4rem"
								:preview-full-image="operBackFilePreview">
								<img v-show="operIdCardBack.length===0" style="height: 4rem;overflow: hidden;"
									src="@/assets/images/kuan_gallery.svg">
							</van-uploader>
							<div class="text12 textcolor333 margin_top_2">点击上传背面照片</div>
						</div>
					</div>
				</div>
				<div class="all_tips_content_card margin_top_5">
					<div class="text14 textcolor333 font_weight_900 ">
						创建电子印章</div>
					<div style="margin: 0 auto;border:1px solid #ddd;border-radius: .3rem;padding: .5rem 0;"
						class="all_text_center">
						<van-uploader v-if="sealStyle === 0" accept="image/*" v-model="imageFiles"
							:before-read="beforeRead" :after-read="afterReadSeal" preview-size="7rem"
							:preview-full-image="false">
							<img v-show="imageFiles.length===0" style="width: 7rem; height: 7rem; "
								src="@/assets/images/fang_gallery.svg">
						</van-uploader>
						<div v-if="sealStyle === 1" class="display_flex" style="justify-content: center;">
							<div style="width: 7rem; height: 7rem;position: relative;">
								<img id="img" style="width: 7rem; height: 7rem;" :src="imgSrc">
								<img style="position: absolute;left: 0;top: 0;z-index: 10;width: 7rem; height: 7rem; object-fit: fill;"
									:src="imgWaterMarker">
								<!-- 			<canvas id="waterCanvas" style="position: absolute;left: 0;top: 0;z-index: 10;"
									:width="waterCanvasWidth" :height="waterCanvasHeight"></canvas> -->
							</div>
						</div>
					</div>
					<div v-if="sealStyle === 0" class="text14 textcolor333" style="margin: 0 auto;text-align: center;">
						点击拍照/上传</div>
				</div>
				<div class="all_tips_content_card margin_top_5" style="margin-bottom: 3.5rem;">
					<div class="text14 textcolor666 margin_top_10">创建方式</div>
					<div class="all_tips_input display_flex">
						<div class="width_flex all_height_line14 text14 textcolor333 font_weight_900">{{sealStyleText}}
						</div>
						<div class="selectstyle all_height_line14 text14 textcolor333 font_weight_900 display_flex"
							@click="showSealStyleBottom = true;showSealTypeBottom = false">更换方式</div>
					</div>
					<div class="all_tips_red_after text14 textcolor666 margin_top_10">印章名称</div>
					<div class="all_van_field" :class="{ isfocus: nameFocus }">
						<div class="display_inline_block" :style="{width: sealStyle === 1?'80%':'100%'}">
							<van-field v-model="sealName" type="text" placeholder="请输入印章名称" clearable
								@focus="getFocus()" @blur="onblur()" @keydown.enter="createSealTool()">
							</van-field>
						</div>
						<button v-if="sealStyle == 1"
							class="display_inline_block backgroundC_main text14 textcolorwhite all_line_height16"
							style="width: 18%;border-radius: .2rem;" @click="createClick()">生成</button>
					</div>
					<div class="text14 textcolor666 margin_top_10">印章类型</div>
					<div class="all_tips_input display_flex">
						<div class="width_flex all_height_line14 text14 textcolor333 font_weight_900">{{sealTypeText}}
						</div>
						<div class="selectstyle all_height_line14 text14 textcolor333 font_weight_900 display_flex"
							style="width:3rem;" @click="showSealTypeBottom = true;showSealStyleBottom = false">更换</div>
					</div>
					<div v-if="sealStyle === 0" class="text12 textcolor333 margin_top_2">
						建议上传扫描版印章图片，分辨率为120，宽高最好210*210，大小不超过1.5M</div>
				</div>
				<div class="all_tips_bottom_card">
					<button class="all_button22 width_100 text16 bmain_active" @click="sumbit()">提交</button>
				</div>
			</div>
		</div>
		<!-- 选择印章方式 -->
		<van-popup v-model:show="showSealStyleBottom" position="bottom">
			<div class="selectStyleList">
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="selectStyle(1)">
					<img style="width:2rem;height: 2rem;  margin:.5rem .8rem;" src="@/assets/images/online_make.svg">
					<div class="display_inline_block" style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900 ">在线制作（推荐）</div>
						<div class="text12 textcolor999">在线定制化生产电子印章</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="selectStyle(0)">
					<img style="width:2rem;height: 2rem; margin:.5rem .8rem;" src="@/assets/images/album_select.svg">
					<div class="display_inline_block" style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900 ">上传印章图片</div>
						<div class="text12 textcolor999">上传印章照片或扫描图片生产电子印章</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="all_height_line24 text14 textcolor999 all_text_center" @click="showSealStyleBottom = false">
					取&nbsp;&nbsp;消
				</div>
			</div>
		</van-popup>
		<!-- 选择印章类型 -->
		<van-popup v-model:show="showSealTypeBottom" position="bottom">
			<div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(0)">
					合同专用章</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(1)">
					收货确认专用章
				</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(2)">
					交货确认专用章
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext all_height_line24 text14 textcolor999" @click="showSealTypeBottom = false">
					取&nbsp;&nbsp;消</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Uploader,
		Field,
	} from 'vant';
	Vue.use(Uploader).use(Field);
	export default {
		data() {
			return {
				//企业申请id
				applyId: '',
				//ca认证详情
				applyDetail: '',
				//营业执照
				businessLicense: [],
				//企业营业执照fileId
				licenseFileId: '',
				licenseFilePreview: false,
				//法人身份证正面
				legalIdCardFront: [],
				//法人身份证背面
				legalIdCardBack: [],
				//法人身份证正面fileId
				legalFrontFileId: '',
				legalFrontFilePreview: false,
				//法人身份证反面fileId
				legalBackFileId: '',
				legalBackFilePreview: false,
				//经办人身份证正面
				operIdCardFront: [],
				//经办人身份证背面
				operIdCardBack: [],
				//操作人身份证正面fileId
				operFrontFileId: '',
				operFrontFilePreview: false,
				//操作人身份证反面fileId
				operBackFileId: '',
				operBackFilePreview: false,

				//1在线制作  0 图片上传
				sealStyle: 1,
				sealStyleText: '在线制作',
				//印模名称
				sealName: '',
				//印模类型
				sealType: 0,
				sealTypeText: '合同专用章',
				//选择印模制作方式
				showSealStyleBottom: false,
				//选择印模类型
				showSealTypeBottom: false,
				nameFocus: false,
				//印章
				imageFiles: [],
				imgSrc: '',
				//水印base64
				imgWaterMarker: '',
				//水印宽高
				// waterCanvasWidth: 250,
				// waterCanvasHeight: 250,
				//canvas: null,
			}
		},
		methods: {
			//重新提交ca申请
			sumbit() {
				if (!this.licenseFileId) {
					this.$Toast('请选择企业营业执照图片！')
					return
				}
				if (!this.legalFrontFileId) {
					this.$Toast('请选择企业法人身份证图片！')
					return
				}
				if (!this.legalBackFileId) {
					this.$Toast('请选择企业法人身份证图片！')
					return
				}
				if (!this.operFrontFileId) {
					this.$Toast('请选择经办人身份证图片！')
					return
				}
				if (!this.operBackFileId) {
					this.$Toast('请选择经办人身份证图片！')
					return
				}
				this.uploadSignet()
			},
			//上传印章
			uploadSignet() {
				let params = null
				if (this.sealStyle == 1) {
					if (!this.sealName || !this.imgSrc) {
						this.$Toast('请输入印模名称，并生成印模！')
						return
					}
					params = {
						base64Data: this.imgSrc.replace(/^data:image\/\w+;base64,/, ""),
						//印模需要处理的传 空null，不需要处理的不传或者传png等
						type: 'png',
					}
				} else if (this.sealStyle == 0) {
					if (!this.sealName) {
						this.$Toast('请输入印模名称！')
						return
					}
					if (this.imageFiles.length == 0) {
						this.$Toast('请选择印模图片！')
						return
					}
					params = {
						base64Data: this.imageFiles[0].content.replace(/^data:image\/\w+;base64,/, ""),
						//印模需要处理的传 空null，不需要处理的不传或者传png等
						type: null,
					}
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/file/api/uploadBase64", JSON.stringify(params)).then((res) => {
					if (res.success && res.data) {
						this.saveCAauthApply(res.data.fileId)
					} else {
						this.$store.dispatch(this.$LoadShow, false)
						this.$Toast(res.message || '上传文件失败，请重试！')
					}
				});
			},
			//保存ca申请
			saveCAauthApply(signetFileId) {
				let that = this
				this.$post('/cert/api/saveApply', JSON.stringify({
					applyId: this.applyId,
					//法人身份类型0 身份证  1 护照
					identityType: 0,
					//办理人身份证原件或者复印件：1 身份证复印件，0 身份证正反面
					isOperFont: 0,
					//法人身份证原件或者复印件：1 身份证复印件，0 身份证正反面
					islegalFont: 0,
					//法人身份证附件id
					//legalCopyFileId: "",
					//法人身份证反面fileId
					legalBackFileId: this.legalBackFileId,
					//法人身份证正面fileId
					legalFrontFileId: this.legalFrontFileId,
					//企业营业执照fileId
					licenseFileId: this.licenseFileId,
					//操作人身份证反面fileId
					operBackFileId: this.operBackFileId,
					//操作人身份证正面fileId
					operFrontFileId: this.operFrontFileId,
					//操作人身份证附件id
					//operCopyFileId: '',
					//corpId: '',
					corpName: this.applyDetail.corpName,
					creditCode: this.applyDetail.creditCode,
					//公司注册地址
					registerAddress: this.applyDetail.registerAddress,
					//0 合同专用章 1 收货 2 交货
					signetType: this.sealType,
					//印模形式 0 上传印模 1 一键生成 
					isGenerate: this.sealStyle,
					//印模文件id
					signetFileId: signetFileId,
					//印模名称
					signetName: this.sealName
				})).then((res) => {
					if (res.success) {
						this.$post('/cert/api/submitApply/'+that.applyId, {}).then((resc) => {
							that.$store.dispatch(that.$LoadShow, false)
							if (resc.success) {
								that.jump()
							} else {
								that.$Toast(resc.message || '请求失败，请重试！')
							}
						})
					} else {
						this.$store.dispatch(this.$LoadShow, false)
						this.$Toast(res.message || '请求失败，请重试！')
					}
				})
				
				
			},
			//跳转到状态页
			jump() {
				this.$router.push({
					path: 'enterprisecaapplystatus',
					query: {
						corpName: this.applyDetail.corpName,
					}
				})
			},
			//验证图片上传
			beforeRead(file) {
				if (file.type === 'image/*') {
					this.$Toast('请选择图片文件');
					return false;
				}
				return true;
			},
			//营业执照压缩
			afterReadBL(file) {
				this.licenseFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > 524288) {
					this.Tool.compressImage(file, 512, false).then((res) => {
						this.uploadBase64('bl', file, res.data)
					})
				} else {
					this.uploadBase64('bl', file, file.content)
				}
			},
			//法人身份证正面
			afterReadLCF(file) {
				this.legalBackFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > 524288) {
					this.Tool.compressImage(file, 512, false).then((res) => {
						this.uploadBase64('lcf', file, res.data)
					})
				} else {
					this.uploadBase64('lcf', file, file.content)
				}
			},
			//法人身份证反面
			afterReadLCB(file) {
				this.legalBackFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > 524288) {
					this.Tool.compressImage(file, 512, false).then((res) => {
						this.uploadBase64('lcb', file, res.data)
					})
				} else {
					this.uploadBase64('lcb', file, file.content)
				}
			},
			//经办人身份证正面
			afterReadOCF(file) {
				this.operFrontFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > 524288) {
					this.Tool.compressImage(file, 512, false).then((res) => {
						this.uploadBase64('ocf', file, res.data)
					})
				} else {
					this.uploadBase64('ocf', file, file.content)
				}
			},
			//经办人身份证反面
			afterReadOCB(file) {
				this.operBackFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > 524288) {
					this.Tool.compressImage(file, 512, false).then((res) => {
						this.uploadBase64('ocb', file, res.data)
					})
				} else {
					this.uploadBase64('ocb', file, file.content)
				}
			},
			//上传营业执照，身份证正反面
			uploadBase64(flag, file, data) {
				console.log(flag)
				this.$post('/file/api/uploadBase64', JSON.stringify({
						base64Data: data.replace(/^data:image\/\w+;base64,/, ""),
						type: 'png'
					}))
					.then((res) => {
						if (res.success && res.data) {
							file.status = 'success';
							file.message = '上传成功';
							switch (flag) {
								case 'bl':
									this.licenseFileId = res.data.fileId
									break;
								case 'lcf':
									this.legalFrontFileId = res.data.fileId
									break;
								case 'lcb':
									this.legalBackFileId = res.data.fileId
									break;
								case 'ocf':
									this.operFrontFileId = res.data.fileId
									break;
								case 'ocb':
									this.operBackFileId = res.data.fileId
									break;
							}
							return res.data.fileId
						} else {
							file.status = 'failed';
							file.message = '上传失败';
							return ''
						}
					})
			},
			//获取文件base64
			getBase64(flag, fileId) {
				//console.log(flag)
				this.$store.dispatch(this.$LoadShowLevel, true)
				this.$get('/file/api/downloadBase64no/' + fileId)
					.then((res) => {
						this.$store.dispatch(this.$LoadShowLevel, false)
						if (res.success && res.data) {
							switch (flag) {
								case 'bl':
									this.businessLicense.push({
										content: 'data:image/png;base64,' + res.data
									})
									break;
								case 'lcf':
									this.legalIdCardFront.push({
										content: 'data:image/png;base64,' + res.data
									})
									break;
								case 'lcb':
									this.legalIdCardBack.push({
										content: 'data:image/png;base64,' + res.data
									})
									break;
								case 'ocf':
									this.operIdCardFront.push({
										content: 'data:image/png;base64,' + res.data
									})
									break;
								case 'ocb':
									this.operIdCardBack.push({
										content: 'data:image/png;base64,' + res.data
									})
									break;
							}
						}
					})
			},
			//超过500kb压缩
			afterReadSeal() {
				if (file.file.size > 524288) {
					this.Tool.compressImage(file, 512, true).then((res) => {
						this.imageFiles[0].content = res.data
					})
				}
			},
			//工具类生成印章
			createSealTool() {
				if (this.sealStyle != 1) {
					return
				}
				this.imgSrc = this.Tool.createSeal(this.sealName, this.sealTypeText)
				//this.createSealWaterMarker()
			},
			//生成水印
			createSealWaterMarker() {
				// if (this.sealStyle != 1) {
				// 	return
				// }
				this.imgWaterMarker = this.Tool.createWaterMarker()
				//console.log('生成水印')
			},
			//获取焦点
			getFocus() {
				this.nameFocus = true
			},
			//失去焦点
			onblur() {
				this.nameFocus = false
				this.createSealTool()
			},
			createClick() {
				this.createSealTool()
			},
			//选择认证方式
			selectStyle(index) {
				this.sealStyle = index
				switch (index) {
					case 0:
						this.sealStyleText = '图片上传'
						break;
					case 1:
						this.sealStyleText = '在线制作'
						break;
				}
				this.showSealStyleBottom = false
				this.createSealTool()
			},
			//选择章样式
			selectType(index) {
				this.sealType = index
				switch (index) {
					case 0:
						this.sealTypeText = '合同专用章'
						break;
					case 1:
						this.sealTypeText = '收货确认专用章'
						break;
					case 2:
						this.sealTypeText = '交货确认专用章'
						break;
				}
				this.showSealTypeBottom = false
				this.createSealTool()
			},
			//获取ca申请详情
			getCertApplyDetail() {
				this.$store.dispatch(this.$LoadShowLevel, true)
				this.$get('/cert/api/getCaApplyDetail/' + this.applyId)
					.then((res) => {
						if (res.success && res.data) {
							this.applyDetail = res.data
							this.sealName = this.applyDetail.signetName
							this.sealType = this.applyDetail.signetType
							this.selectType(this.sealType)
							this.licenseFileId = this.applyDetail.licenseFileId
							this.legalFrontFileId = this.applyDetail.legalFrontFileId
							this.legalBackFileId = this.applyDetail.legalBackFileId
							this.operFrontFileId = this.applyDetail.operFrontFileId
							this.operBackFileId = this.applyDetail.operBackFileId
							this.getBase64('bl', this.licenseFileId)
							this.getBase64('lcf', this.legalFrontFileId)
							this.getBase64('lcb', this.legalBackFileId)
							this.getBase64('ocf', this.operFrontFileId)
							this.getBase64('ocb', this.operBackFileId)
						}
						this.$store.dispatch(this.$LoadShowLevel, false)
					})
			},
			//初始化
			init() {
				this.applyId = this.$route.query.applyId
				// if (this.waterCanvasWidth === 250) {
				// 	this.waterCanvasWidth = document.getElementById('img').clientWidth
				// 	this.waterCanvasHeight = document.getElementById('img').clientHeight
				// }
				this.getCertApplyDetail()
				this.createSealWaterMarker()
			},
		},
		mounted() {
			this.init()
		},
		beforeDestroy() {
			//自动回收
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	::v-deep .van-cell {
		padding: 10px .3rem;
	}

	::v-deep .van-image__img {
		object-fit: contain !important;
	}
</style>